import { z } from 'zod';
export const loginRequestSchema = z.object({
    email: z.email('Informe um e-mail válido').max(254),
    password: z.string().min(1, 'Informe a senha').max(200),
});
/** Próximo passo após a senha: sempre há MFA (obrigatório para a equipe). */
export const loginResponseSchema = z.object({
    next: z.enum(['mfa_setup', 'mfa_verify']),
    userName: z.string(),
});
export const mfaSetupResponseSchema = z.object({
    otpauthUri: z.string(),
    secret: z.string(),
    issuer: z.string(),
    account: z.string(),
});
export const mfaVerifyRequestSchema = z.union([
    z.object({ code: z.string().regex(/^\d{6}$/, 'O código tem 6 dígitos') }),
    z.object({ recoveryCode: z.string().regex(/^[a-z2-7]{4}-?[a-z2-7]{4}$/i, 'Código de recuperação no formato xxxx-xxxx') }),
]);
export const mfaVerifyResponseSchema = z.object({
    /** Só no primeiro cadastro do autenticador: exibidos uma única vez. */
    recoveryCodes: z.array(z.string()).optional(),
    recoveryCodesRemaining: z.number().int().optional(),
});
export const membershipSummarySchema = z.object({
    organizationId: z.uuid(),
    slug: z.string(),
    tradeName: z.string(),
    roles: z.array(z.string()),
});
export const meResponseSchema = z.object({
    user: z.object({ id: z.uuid(), name: z.string(), email: z.string() }),
    organizations: z.array(membershipSummarySchema),
    activeOrganizationId: z.uuid().nullable(),
    permissions: z.array(z.string()),
    /** true só no host admin.* e para quem está em platform_admins. */
    isPlatformAdmin: z.boolean(),
});
export const setActiveOrganizationSchema = z.object({ organizationId: z.uuid() });
/** Header anti-CSRF exigido em toda requisição que altera estado. */
export const CSRF_HEADER = 'x-requested-with';
export const CSRF_VALUE = 'dnx';
// ------------------------------------------------------------ convite e senha (links por e-mail)
const newPassword = z.string().min(12, 'Use pelo menos 12 caracteres').max(200);
const linkToken = z.string().min(20).max(100);
export const tokenRequestSchema = z.object({ token: linkToken });
/** O que a tela do convite mostra antes de a pessoa criar a senha. */
export const inviteInfoSchema = z.object({ name: z.string(), email: z.string(), organizationName: z.string().nullable() });
export const inviteAcceptSchema = z.object({ token: linkToken, password: newPassword });
export const forgotPasswordSchema = z.object({ email: z.email('Informe um e-mail válido').max(254) });
export const resetPasswordSchema = z.object({ token: linkToken, password: newPassword });
export const changePasswordSchema = z.object({ currentPassword: z.string().min(1).max(200), newPassword });
//# sourceMappingURL=auth.js.map